import axios from 'axios';
import toast from 'react-hot-toast';



const getBaseURL = () => {
  const envUrl = process.env.REACT_APP_API_URL;
  if (!envUrl) return 'http://localhost:5002/api';
  
  // If the URL already ends with /api, don't add it again
  return envUrl.endsWith('/api') ? envUrl : `${envUrl}/api`;
};

const api = axios.create({
  baseURL: getBaseURL(),
  headers: { 'Content-Type': 'application/json' },
});


api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('cms_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  res => res,
  err => {
    // console.error('[CMS API] Error:', err.response?.status, err.config?.url);
    if (err.response?.status === 401) {
      // ONLY redirect if we are NOT in the middle of an SSO attempt
      const hasSSO = window.location.search.includes('sso_token') || window.location.hash.includes('sso_token');
      const isMeRequest = err.config?.url?.includes('/auth/me');

      if (!hasSSO && !isMeRequest) {
        // console.log('[CMS API] 401 Unauthorized - Redirecting to login');
        localStorage.removeItem('cms_token');
        localStorage.removeItem('cms_user');
        window.location.href = '/login';
      } else {
        // console.log('[CMS API] 401 Unauthorized during SSO/Verification - Suppressing redirect');
      }
    }
    const msg = err.response?.data?.message || 'Something went wrong';
    toast.error(msg);
    return Promise.reject(err);
  }
);

export default api;
